//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum FeeRateType {

  Flat = 1,

  Percent = 2,

}

export default FeeRateType;